import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Analytics from './components/Analytics';
import Home from './pages/Home';
import Services from './pages/Services';
import WebsiteManagement from './pages/WebsiteManagement';
import TechnicalSupport from './pages/TechnicalSupport';
import BusinessEmail from './pages/BusinessEmail';
import ManagedHosting from './pages/ManagedHosting';
import WebDesignDevelopment from './pages/WebDesignDevelopment';
import TechnologyConsulting from './pages/TechnologyConsulting';
import AgencyPlans from './pages/AgencyPlans';
import Contact from './pages/Contact';
import DigitalReview from './pages/DigitalReview';
import GetStarted from './pages/GetStarted';
import About from './pages/About';
import Examples from './pages/Examples';
import Support from './pages/Support';
import AgencyServices from './pages/AgencyServices';
import WhiteLabelWordPress from './pages/WhiteLabelWordPress';
import WhiteLabelSupport from './pages/WhiteLabelSupport';
import AgencyHosting from './pages/AgencyHosting';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import './index.css';

function App() {
  return (
    <Router>
      <Analytics />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/website-management" element={<WebsiteManagement />} />
          <Route path="/services/technical-support" element={<TechnicalSupport />} />
          <Route path="/services/business-email" element={<BusinessEmail />} />
          <Route path="/services/managed-hosting" element={<ManagedHosting />} />
          <Route path="/services/web-design-and-development" element={<WebDesignDevelopment />} />
          <Route path="/services/technology-consulting" element={<TechnologyConsulting />} />
          <Route path="/agency-plans" element={<AgencyPlans />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/digital-review" element={<DigitalReview />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/about" element={<About />} />
          <Route path="/who-we-help" element={<Examples />} />
          <Route path="/support" element={<Support />} />
          <Route path="/agency-services" element={<AgencyServices />} />
          <Route path="/agency-services/white-label-wordpress" element={<WhiteLabelWordPress />} />
          <Route path="/agency-services/white-label-support" element={<WhiteLabelSupport />} />
          <Route path="/agency-services/agency-hosting" element={<AgencyHosting />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;